module.exports = __webpack_public_path__ + "img/download_img_new.2afc4454.png";